
export const Language = {
    moneySignBeRight: false, //货币符号是否在后面
    moneySign: "₺",

    newAPPVersionTip: "New version available. Please refresh to continue playing.",
    NetworkError: "Ağ sorunu. Yenile veya tekrar giriş yap. Yardım için destekle iletişime geçin.",
    NetworkTimeout: "Zaman aşımı",

    user_kicked_out: "Hesabınıza başka bir cihazdan giriş yapıldığından çıkış yapıldı.",

    ConfigError: "Oyun yapılandırması alınamadı. Yenile veya tekrar giriş yap. Yardım için destekle iletişime geç.",

    LoadBundlesError: "Paketler yüklenemedi. Yenile veya tekrar giriş yap. Yardım için destekle iletişime geç.",
    HotUpdateError: "Load assets fail. Try refresh or relogin. Need help? Contact support.",

    exit_game_title:"Tips",
    exit_game_btn_yes:"Yes",
    exit_game_btn_no:"No",
    exit_game_confirm: "Oyundan çıkmak istediğine emin misin?",
    open_pay_url_confirm: "777 Vegas onaylı güvenilir siteye yönlendiriliyorsunuz. Devam etmek için:​​ EVET",

    MobileNumInvalid: "Lütfen geçerli bir telefon numarası girin.",
    PwdInvalid: "Geçersiz şifre", 
    InvalidSmscode: "Lütfen geçerli OTP kodunu girin.",
    OTPHasSent: "OTP kodu gönderildi.",
    BindPhoneSuccess: "Telefon numarası eklendi! Lütfen telefon numaranızla tekrar giriş yapın.",

    Not_sign: "Bu etkinlik sadece VIP oyuncular içindir. VIP seviyesine yükselmek için lütfen önce bakiye yükleyin.",

    VipCardItem_days: "Gün​",
    VipCardItem_reward_now: "%s NAKİT + %s BONUS HEMEN KAZANIN",  //立即获得%d现金+%d奖金
    VipCardItem_reward_everyDay: "HER GÜN %s ₺ NAKİT + %s ₺ BONUS KAZANIN!",  //每天获得%d现金+%d奖金
    VipCardItem_cash_everyDay: "HER GÜN %s ₺ NAKİT KAZAN",  //每天获得%d现金
    VipCardItem_bouns_everyDay: "​​HER GÜN %s ₺ BONUS KAZAN",  //每天获得%d奖金
    VipCardItem_try_later: "Ödeme işleminiz devam ediyor. Lütfen bir süre sonra tekrar deneyin.",  //付款正在进行中，请稍后再试。
    Buy_vip_success: "VIP Ayrıcalıkları Satın Alındı!",
    Get_vip_reward_success: "Ödüller Teslim Edildi!",
    PayChannel_toast: "Yatırma işleminiz devam ediyor. Lütfen bekleyin.​",

    Vip_Unlocks: "≥$10'da Açılır",
    ShareModule_click_link: "Merhaba arkadaşım! Bağlantıya tıkla ve hemen çevrimiçi büyük paralar kazan!",  //你好，我的朋友!点击链接，立即在线赢取大额现金！
    ShareModule_whatapp_tip: "Lütfen önce WhatsApp'ı yükleyin.",  //请先安装WhatsApp
    ShareModule_Facebook_tip: "Lütfen önce Facebook'u yükleyin.",  //请先安装Facebook
    ShareText_loadingNum: "/%s Geçerli Arkadaş",
    ShareText_rule_reward: "Ark. İlk Yatırımdan %s",
    ShareText_rule_pay: "Her Ark. Yatırımdan %s",
    ShareText_rule_level: "≥%s Arkadaş (K.1+K.2) ilk yatırımı tamamladı",

    modify_nickname_success: "Takma Ad Değiştirme Başarılı!",
    modify_user_icon_success: "Kullanıcı simgesi değiştirme başarılı!",

    WithdrawPanel_add_bank: "Lütfen önce cüzdan adresinizi ekleyin.", //请先添加银行账户.
    withdraw_error_1: "The Pay TM ID is incorrect!",
    withdraw_error_2: "The email format is incorrect!",
    withdraw_error_3: "The withdrawal amount is null!",
    withdraw_error_4: "Minimum cash withdrawal is %d.",
    withdraw_error_5: "verification code sent",
    withdraw_error_6: "Verification code error!",
    withdraw_error_7: "BankInfo error",
    WithdrawPremiumTips: "Sadece VIP oyuncular para çekebilir. \nVIP olmak için hemen bakiye yükleyin.",
    WithdrawSuccessDialog: "Çekim Talebiniz Başarılı!\nÇekiminiz 10-60 dakika içinde hesabınıza geçecektir. \nYardım için hemen destek ekibine ulaşın.",
    dialog_title_tips: "Tips",
    h5_get_user_scores_fail: "Ağ kalitesi düşük. Lütfen tekrar bağlanmayı deneyin.",
    h5_get_user_scores_confirm: "Bağlanıyor…",
    withdraw_tips_content: "Bugünkü para çekme hakkınız doldu.  \n Lütfen VIP seviyenizi yükselterek daha fazla çekim hakkı kazanın.",
    withdraw_tips_confirm: "Onayla",
    FillEWalletDialogRs_invalid_number: "Para çekme adresi başarıyla eklendi!",  //帐号无效。帐号不应从0开始。
    FillBankInfoDialog_add_bank_success: "Add Bank Card Success", //添加银行卡成功
    beneficiary_name: "Enter Beneficiary Name",  //输入受益人姓名
    BankInfoForms_bank_number: "Enter Bank Account Number",  //输入银行账号
    EWalletInfoForms_ewallet_number: "Enter EWallet Account Number",  //输入电子钱包账号
    EWalletInfoForms_valid_bank_number: "Please enter a valid EWallet Account Number",  //请输入有效的电子钱包账号
    EWalletInfoForms_same_ewallet_number: "EWallet Account Number input must be the same",  //电子钱包账号输入必须相同
    EWalletInfoFormsRs_name: "Enter Account Number",  //输入账号
    EWalletInfoFormsRs_ID_number: "Enter ID Card Number",  //输入身份证号码
    FillBankInfoDialog_IFSC_number: "Enter IFSC Code Number",  //输入IFSC代码
    EWalletInfoFormsRs_valid_number: "Please enter a valid Account Number",  //请输入有效的帐号
    EWalletInfoFormsRs_same_number: "Account Number input must be the same",  //帐号输入必须相同
    EWalletInfoFormsRs_valid_ID_number: "Please enter a valid ID Card Number", //请输入有效的身份证号码
    FillBankInfoDialog_valid_IFSC_number: "Please enter a valid IFSC Code Number",  //请输入有效的IFSC代码
    FillBankInfo_Error: "IFSC Code is incorrect. Please enter it again.",
    FillBankInfoFifth_Error: "The 5th character of the IFSC Code must be '0'",
    valid_name: "Please enter a valid Beneficiary Name",  //请输入有效的受益人姓名
    bank_name: "Enter Bank Name",  //输入银行名称
    valid_bank_number: "Please enter a valid Bank Account Number",  //请输入有效的银行帐号
    same_bank_number: "Bank Account Number input must be the same",  //银行账号输入必须相同
    valid_bank_name: "Please enter a valid Bank Name",  //请输入有效的银行名称
    houseRace_winTxet: "Congrats! %s win %s in %s!",  //跑马灯恭喜中奖
    tips: "Tips",  //提示
    confirm: "ONAYLA",  //确认
    notice: "Uyarı", //通知
    Notice: "Uyarı", //通知大写
    yes: "EVET", //是的
    no: "HAYIR", //不是

    transaction_no_more_data: "İşlem için daha fazla veri yok",
    transaction_is_first_page: "İşlemler ilk sayfada",
    AddCashModule_failFun_tip: "Lütfen ağ bağlantınızı kontrol edin ve yeniden deneyin.", //请检查网络并重试
    AddCashPayH5: "Lütfen butona %s saniye sonra tekrar tıklayın",

    can_find_subgame_info: "Oyun bilgileri bulunamadı",
    subgame_is_closed: "Bu oyun yakında sizlerle!",

    VipEquityView_showLevelUi_Recharge: "VIP%s olmak için %s'ü yeniden yükleyin",
    VipEquityView_showCloseTip_weelpar: "Haftalık bahis miktarı≥%s",
    VipEquityView_showCloseTip_halfMonthpar: "15 günlük bahis tutarı ≥%s",
    VipEquityView_showCloseTip_Monthpar: "Aylık bahis tutarı ≥ %s",

    TransactionPanel_activity: "Promosyon", // 游戏记录 - 文字 - 活动
    TransactionPanel_money_add: "Yatırım Geçmişi", // 游戏记录 - 文字 - 添加货币
    TransactionPanel_withdrawal: "Çekim Geçmişi", // 游戏记录 - 文字 - 退出
    TransactionPanel_win: "Kazanç Geçmişi", // 游戏记录 - 文字 - 赢
    TransactionPanel_loss: "Kayıp Geçmişi", // 游戏记录 - 文字 - 输

    UnPay: "Devam Ediyor", // 提现中
    FinishPay: "Başarılı", // 成功
    PayFail: "fail", // 提现失败

    WithdrawFail: "Anormal arıza", // 提现异常失败
    WithdrawFailHandled: "İstisna hatası işlendi", // 异常失败已处理
    WithdrawRejected: "Reddedildi", // 提现已拒绝

    Vip_ERROR: "Ağ bağlantınızı kontrol edin",
    VipRewardGetToday: "Bugün Alınan",
    VipRewardTime: "Kalan Süre: ",
    PayAmount: "Yükleme Miktarı ", // "充值金额:",
    Arrived: " Alındı", // "已到账!",

    CopySuccess: "Başarıyla kopyalandı.",
    CopyFail: "Kopyalama başarısız.",
    CopyString: "\nMerhaba arkadaşım! Bağlantıya tıkla ve hemen çevrimiçi büyük paralar kazan!", //复制后半段
    MoreClick: "Daha Fazla Etkinlik Yakında!",
    EggCapsuleStart: "Başla(%s)",
    EggCapsuleStartEnd: "Başlıyor",
    EggCapsuleErroe: "Etkinlik veri hatası",
    Sharing_link_error: "Paylaşım linki veri hatası",//分享链接错误
    WelcomeTip1: "1. YATIRIM: %%s'ye KADAR ARTIR",
    WelcomeTip2: "2. YATIRIM: %%s'ye KADAR TAKVİYE",
    WelcomeTip3: "3. YATIRIM: %%s'ye KADAR GÜÇLENDİR",

    BindActivityReward: "Hoşgeldin",
    BindActivityBonus: "Ücretsiz bonus",
    BindActivityDailyCash: "Günlük Ödül",
    BindActivityVipCard: "VIP Kartı",
    BindActivityVIPPrivilege: "VIP Ayrıcalığı",
    BindActivityLuckyWheel: "Şans Çarkı",
    BindActivityLuckyGacha: "Şans Gachası",
    BindActivityRich1: "Kadar Ödül ",
    BindActivityRich2: "Bonusunuzu Bedava Nakite Çevirin",
    BindActivityRich3: "Her Gün Bedava Nakit Al!",
    BindActivityRich4: "Kadar Ödül ",
    BindActivityRich5: "VIP Ödüllerinizi Alın",
    BindActivityRich6: "<color=#FFFFFF>Arkadaş Davet Et = </color><color=#FF3838>2K</color><color=#FFFFFF> Bedava Bonus!</color>",
    BindActivityRich7: "ÇEVİR KAZAN",
    FreeSpinEverydayTip:"Free Spins – Play Slots for FREE!",

    Game_type_name_palyer: 'Geçmiş Oyunlar',
    Game_type_name_hot: 'Popüler Oyunlar',
    Game_type_name_slots: 'Slotlar',
    Game_type_name_tableCard: 'Masa & Kart',
    Game_type_name_crash: 'Patlama Oyunları',
    Game_type_name_fishing: 'Balık Oyunları',
    Game_type_name_casino: 'Gerçek Krupiyeler',

    SubgameInfoTip1: "Bakiyeniz yetersiz. Hemen para yatırın.",
    SubgameInfoTip2: "Tüm bakiyeler bahis için kullanılabilir.",
    SubgameInfoTip3: "Serbest Nakit bakiyesi bu oyunda kullanılamaz.",
    VipConversionTip: "<size=19><color=#ffffff>Bahis yaptıkça bonusunuz Serbest Nakit bakiyesine dönüşecektir.\n Çevrim oranınız: </color>",
    vipCardUp: "Daha Fazla Al",
    vipEquiteConversion1: "<size=14><color=#FFD223>VIP",
    vipEquiteConversion2: "<color=#ffffff> Dönüşüm oranı: </color>",

    rolloverAllType: "Hepsi",
    rolloverDeposit: "Yatırım",
    rolloverFreeCash: "Ücretsiz Bakiye",
    RolloverALLSTATUS: "Tüm Durumlar",
    RolloverNOTSTARTED: "Başlamadı",
    RolloverONGOING: "Devam Ediyor",
    RolloverCOMPLETED: "Tamamlandı",
    RolloverCANCELED: "İptal Edildi",

    TurnTableTips: "aldı!​",
    TurnTableReward1: " Macbook Pro 16-inch",
    TurnTableReward2: " iPhone 16 Pro ",
    TurnTableReward3: " 2 Çevirme",
    TurnTableReward4: " 1 Çevirme",
    TurnTableReward5: " Ücretsiz Bakiye",
    TurnTableError: "Ne kadar yatırırsanız yatırın, 1 Çevirme Hakkı Kazanın.",

    updateLoading: "Yükleniyor......%s%",
    vipCardRedTip: "Alın",
}

